export const column = {
    namespaced: true,
    state: {
        columnData:[],
    },
    actions: {
        getEventColumnsByUser({ commit }) {
            commit('getColumns');
        },
        setEventColumnsByUser({ commit }, columns) {
            commit('setColumns', columns);
        },
    },
    mutations: {
        getColumns(state) {
            return state.columnData;
        },
        setColumns(state, columns) {
            state.columnData = columns
        },
    },
    getters: {
        columnData(state) {
            return state.columnData;
        },
    },
};